export default "{{{text.thirdParty.content}}}";